// extracted by mini-css-extract-plugin
export default {"formCard":"FormCard_formCard__+4+j1"};